import { render, staticRenderFns } from "./GetCreateRouteListData.vue?vue&type=template&id=61585e32&scoped=true&"
import script from "./GetCreateRouteListData.vue?vue&type=script&lang=js&"
export * from "./GetCreateRouteListData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61585e32",
  null
  
)

export default component.exports